// Single source of truth for opening a master-suite step's result in the right
// viewer. UI Automation steps open the dedicated UI result page (same as a
// standalone UI run); process-automation steps open the operation result;
// everything else opens the generic compare result detail.
//
// `detail` is a MasterSuiteDetail-shaped object (from getMasterSuiteDetailResultByJob)
// with: stepResultId, category, subCategory, taskName, stepTestResult,
// stepRunStart, stepRunEnd, [user].
export function navigateToStepResult(navigate, detail) {
  if (!detail?.stepResultId) return;

  const sub = (detail.subCategory || "").toLowerCase();
  const cat = (detail.category || "").toLowerCase();

  // UI Automation → dedicated UI result page (steps, screenshots, errors)
  if (sub === "ui test" || cat === "ui automation" || cat === "ui") {
    navigate("/ui-automation/results", {
      state: {
        resultSummaryKey: detail.stepResultId,
        record: {
          testResult: detail.stepTestResult,
          suiteName: detail.taskName,
          user: detail.user ?? null,
          runStart: detail.stepRunStart,
          runEnd: detail.stepRunEnd,
          subCategory: "UI Test",
        },
      },
    });
    return;
  }

  // Process-automation → operation result detail
  if (
    cat === "process automation" ||
    cat === "process" ||
    [
      "file move, copy or delete",
      "event monitor",
      "extract compressed file",
    ].includes(sub)
  ) {
    navigate("/results/process", { state: { key: detail.stepResultId } });
    return;
  }

  // Compare (file/db) → generic result detail
  navigate("/results/details", { state: { key: detail.stepResultId } });
}

export default navigateToStepResult;
